import { extend } from 'flarum/extend';
import IndexPage from 'flarum/components/IndexPage';

export default function () {    
    extend(IndexPage.prototype, 'navItems', function ({items}) {
        try {
            items.rankings.content.props.icon = "fas fa-chart-line";
        } catch(e) {}
    });
}